import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "name", "checked", "value"]
const _hoisted_2 = ["for", "innerHTML"]

import { computed } from "vue";

// Props

const __default__ = {
    name: 'VueRadioButton',
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    id: {
        type: String,
        required: true
    },
    name: {
        type: String,
        required: true
    },
    value: {
        required: true
    },
    isInline: {
        default: false
    },
    isAdmin: {
        default: true
    },
    hasLabel: {
        default: true
    },
    labelText: {
        type: String,
        required: true
    },
    labelStyle: {
        type: String
    },
    labelClasses: {
        type: String
    },
    modelValue: {},
    selected: {
        type: Boolean,
        default: false
    },
    isRequired: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props;

// Computed methods
// Setting label classes based on isAdmin, hasLabel, and labelStyle props
const setLabelClasses = computed(() => {
    const hasLabel = props.hasLabel,
        hasStyle = props.labelStyle?.toLowerCase();

    return {
        'sr-only': !hasLabel,
        'text-xs font-normal': props.isAdmin && hasStyle === 'light',
        'rd-text-xs rd-font-normal': !props.isAdmin && hasStyle === 'light'
    }
});

// Setting position classes based on isAdmin and isInline props
const setPositionClasses = computed(() => {
    let classes: any;

    if (props.isAdmin) {
        props.isInline ? classes = 'items-center inline-flex' : classes = 'items-center flex';
    }
    else {
        props.isInline ? classes = 'rd-items-center rd-inline-flex rd-relative' : classes = 'rd-items-center rd-flex rd-relative';
    }

    return classes;
});

const setRadioClasses = computed(() => {
    return {
        'rd-relative': !props.isAdmin,
        'form-radio form-radio-green': props.isAdmin
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(setPositionClasses.value)
  }, [
    _createElementVNode("input", {
      type: "radio",
      id: __props.id,
      name: __props.name,
      class: _normalizeClass(setRadioClasses.value),
      checked: __props.selected,
      value: __props.value,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', __props.value)))
    }, null, 42, _hoisted_1),
    (__props.hasLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: __props.id,
          class: _normalizeClass([setLabelClasses.value, __props.labelClasses, __props.isAdmin ? 'mb-0 ml-2.5' : 'rd-ml-2.5 !rd-mb-0']),
          innerHTML: __props.labelText
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})